import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/home/runner/work/farmhand/farmhand/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {cleanupOutdatedCaches as workbox_precaching_cleanupOutdatedCaches} from '/home/runner/work/farmhand/farmhand/node_modules/workbox-precaching/cleanupOutdatedCaches.mjs';
import {registerRoute as workbox_routing_registerRoute} from '/home/runner/work/farmhand/farmhand/node_modules/workbox-routing/registerRoute.mjs';
import {NavigationRoute as workbox_routing_NavigationRoute} from '/home/runner/work/farmhand/farmhand/node_modules/workbox-routing/NavigationRoute.mjs';
import {createHandlerBoundToURL as workbox_precaching_createHandlerBoundToURL} from '/home/runner/work/farmhand/farmhand/node_modules/workbox-precaching/createHandlerBoundToURL.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */




self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});

/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "index.html",
    "revision": "80a42fe894ce3eed31600d8d77591744"
  },
  {
    "url": "electron.js",
    "revision": "b0456826f47539f6c1957c3add5eb959"
  },
  {
    "url": "assets/workbox-window.prod.es5-Bd17z0YL.js",
    "revision": null
  },
  {
    "url": "assets/index-DNPchtK9.js",
    "revision": null
  },
  {
    "url": "assets/index-CNcrTYN-.css",
    "revision": null
  },
  {
    "url": "favicon.ico",
    "revision": "445bb19d4a8fd46eb433dd43cbdce691"
  },
  {
    "url": "logo192.png",
    "revision": "70746d790b8990639d1390337d77d81a"
  },
  {
    "url": "logo512.png",
    "revision": "b044ab46b3f33f0e2d313d961bf1f654"
  },
  {
    "url": "logoMaskable.png",
    "revision": "23be58ccf16df9f43658aad3da30056d"
  },
  {
    "url": "manifest.webmanifest",
    "revision": "3ad071a00582451c9cdeb827b37b9ebe"
  }
], {});
workbox_precaching_cleanupOutdatedCaches();workbox_routing_registerRoute(new workbox_routing_NavigationRoute(workbox_precaching_createHandlerBoundToURL("index.html")));


